import React from "react";


const ClientCard=({
client
})=>{


return(

<div className="client-wrapper">


{
client.link ?

<a 
href={client.link}
target='_blank'
rel='noreferrer'
className="client-logo-card"
>

<img
src={client.logo_url}
alt={client.name}
/>


<div className="service-tooltip">

{
client.services.length > 0 ? (
client.services.map(
(service,index)=>(

<span key={index}>
{service}
</span>

))
) : (
<span>{client.company || client.name}</span>
)
}

</div>


</a>


:


<div className="client-logo-card">

<img
src={client.logo_url}
alt={client.name}
/>


<div className="service-tooltip">

{
client.services.length > 0 ? (
client.services.map(
(service,index)=>(

<span key={index}>
{service}
</span>

))
) : (
<span>{client.company || client.name}</span>
)
}

</div>


</div>


}


</div>


)

}


export default ClientCard;